import { getSelectDropdownListFloatingConfig } from './Select.utils'

export const INPUT_SELECT_SEARCH_INPUT_NAME = 'input-select-search'

export const SELECT_DROPDOWN_LIST_DIVIDER_OPTION_VALUE =
  'select-dropdown-list-divider'

export const SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY = 296

export const SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY = 352

export const SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_ADDITIONAL_INFO = 380

export const SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_SELECT_ALL = 417

export const SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig()
